<!-- eslint-disable vue/html-indent -->
<template>
  <div class="fund-confirmation">
    <form @submit.prevent="fundRequest" class="fund-confirmation__form">
      <!-- Summary Card -->
      <div class="fund-confirmation__card">
        <div class="fund-confirmation__row">
          <span class="fund-confirmation__label">
            {{ swapCurrency ? "Converting" : "Amount" }}
          </span>
          <span class="fund-confirmation__value" v-if="swapCurrency">
            {{ formatAmountToDollar(currentFundPayload.amount, 2, swapCurrency) }}
          </span>
          <span class="fund-confirmation__value" v-else>
            {{ getCurrencySymbol(currency) }} {{ convertToLocale(Number(currentFundPayload.amount)) }}
          </span>
        </div>
        <div v-if="swapCurrency" class="fund-confirmation__row">
          <span class="fund-confirmation__label">To</span>
          <span class="fund-confirmation__value">{{ getCurrencySymbol(currency) }}</span>
        </div>
        <div v-else class="fund-confirmation__row">
          <span class="fund-confirmation__label">Transaction Fee</span>
          <span class="fund-confirmation__value">{{ getCurrencySymbol(currency) }} {{ convertToLocale(Number(currentTransactionFee)) }}</span>
        </div>
        <div class="fund-confirmation__row" v-if="swapCurrency">
          <span class="fund-confirmation__label">Exchange Rate</span>
          <span class="fund-confirmation__value">1 {{ getCurrencySymbol(swapCurrency) }} = {{ formatAmountToDollar(currencyRate, 4, currency) }}</span>
        </div>
        <div class="fund-confirmation__row" v-else-if="fundOptions">
          <span class="fund-confirmation__label">Payment Method</span>
          <span class="fund-confirmation__value">{{ fundingMeans }}</span>
        </div>
      </div>

      <!-- Total Section -->
      <div class="fund-confirmation__total">
        <div class="fund-confirmation__total-row">
          <span class="fund-confirmation__total-label">{{ swapCurrency ? "You will receive" : "Total" }}</span>
          <span class="fund-confirmation__total-value" v-if="swapCurrency">
            {{ formatAmountToDollar(swapConversion, 2, currency) }}
          </span>
          <span class="fund-confirmation__total-value" v-else>
            {{ getCurrencySymbol(currency) }} {{ convertToLocale(Number(currentFundPayload.totalAmount)) }}
          </span>
        </div>
      </div>

      <!-- Submit Button -->
      <button
        type="submit"
        class="fund-confirmation__btn"
        :disabled="loading"
      >
        <span v-if="loading" class="fund-confirmation__spinner"></span>
        <span v-else>Confirm & Pay</span>
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import api from "@/utils/api.js";
import { convertToLocale, formatAmountToDollar, getCurrencySymbol } from "@/utils/helpers.js";
import fundPercent from "@/utils/js/fundPercent.js";
import responseHandler from "@/utils/responseHandler.js";
import { getItem, setItem } from "@/utils/storage.js";

export default {
  name: "FundConfirmationForm",

  emits: ["storeData", "close"],

  components: {},

  props: {
    fundOptions: { type: String, default: () => "", required: true },
  },

  data() {
    return {
      user: getItem("org_details"),
      //   fundPayload: {},
      //   transactionFee: 0,
      fundPercent,
      customizations: {
        title: "GetEquity Payments",
        description: "Purchase of GUSD from GetEquity",
      },

      loading: false,
      // addCard: false,
    };
  },

  inject: ["swapCurrency"],

  computed: {
    ...mapState({
      currency: (state) => state.organisationModule.currency,
      cardDetails: (state) => state.organisationModule.cardDetails,
    }),
    ...mapGetters("organisationModule", ["currencyRate"]),
    ...mapGetters("fundingModule", [
      "currentFundPayload",
      "transactionFee",
      "totalAmount",
      "feeBreakdown",
    ]),

    currentTransactionFee() {
      return this.transactionFee(
        this.fundOptions,
        this.currentFundPayload?.amount,
        this.currency
      );
    },

    fundingMeans() {
      let fundingMeans = null;
      switch (this.fundOptions) {
        case "Fund with debit card":
          fundingMeans = "Flutterwave Card";
          break;
        case "Flutterwave Bank Transfer":
          fundingMeans = "Flutterwave Bank Transfer";
          break;
        case "Bank or Card":
          fundingMeans = "Startbutton";
          break;
        case "P2P Transfers":
          fundingMeans = "Accrue";
          break;
        case "Mobile Money":
          fundingMeans = "Flutterwave M-Pesa";
          break;
        case "Bank Transfer":
          fundingMeans = "Bank Transfer";
          break;
        case "Crypto":
          fundingMeans = "Crypto";
          break;
        case "Fund with Fintech Apps":
          fundingMeans = "ThePeer";
          break;
      }
      return fundingMeans;
    },
    swapConversion() {
      if (this.swapCurrency) {
        return this.currentFundPayload.amount * Number(this.currencyRate);
      }
      return 0;
    },
  },

  mounted() {
    if (!this.currentFundPayload) {
      this.$emit("storeData", "fundAmountForm");
    }
  },

  methods: {
    ...mapActions("organisationModule", ["getWalletBalance", "convertWallet"]),
    ...mapActions(["showToast"]),

    formatAmountToDollar,
    convertToLocale,
    getCurrencySymbol,

    async fundRequest() {
      this.loading = true;
      switch (this.fundOptions) {
        // case "Bank or Card":
        // 	// this.$emit("storeData", "fundConfirmationForm");
        // 	this.flutterwaveFunding();
        // 	break;
        case "Mobile Money":
          this.flutterwaveFunding("mpesa");
          break;
        case "Flutterwave Bank Transfer":
          this.flutterwaveFunding("banktransfer");
          break;
        case "Fund with debit card":
          this.$emit("storeData", "fundConfirmationForm");
          // this.flutterwaveFunding();
          break;
        case "Bank Transfer":
          this.$emit("storeData", "fundConfirmationForm");
          break;
        case "":
          this.$emit("storeData", "fundProvider");
          // this.flutterwaveFunding();
          break;
        case "Fund with Fintech Apps":
          // this.thepeerFunding();
          this.$emit("storeData", "fundConfirmationForm");
          break;
        case "Crypto":
          this.cryptoFunding();
          break;
        case "USD Wallet":
          this.fundFromWallet();
          break;
        case "NGN Wallet":
          this.fundFromWallet();
          break;
        case "KES Wallet":
          this.fundFromWallet();
          break;
        case "P2P Transfers":
          this.accrueFunding();
          break;
        case "Bank or Card":
          this.startButtonFunding();
          break;

        default:
          break;
      }
    },

    async fundFromWallet() {
      const payload = {
        amount: this.currentFundPayload.totalAmount,
        from: this.swapCurrency,
        to: this.currency,
      };
      try {
        const response = await this.convertWallet(payload);
        const { message } = response.data;
        this.loading = false;
        this.showToast({
          description: message,
          display: true,
          type: "success",
        });
        await this.getWalletBalance();
        this.$emit("close", "Fund Wallet");
      } catch (error) {
        this.loading = false;
      }
    },

    async thepeerFunding() {
      // eslint-disable-next-line no-undef
      const thePeerInstance = new ThePeer.directCharge({
        publicKey: `${process.env.VUE_APP_THE_PEER}`,
        amount: this.currentFundPayload.totalAmount * 100,
        currency: this.currency,
        userReference: this.user.thepeer_reference,
        meta: {
          tokens: Number(this.fundPayload.tokens),
          entity: "user",
        },

        onError: function (error) {
          responseHandler.handleError(error);
        },

        onClose: () => {
          this.getWalletBalance();
          this.$emit("close", "Fund Wallet");
        },

        onSuccess: () => {
          this.getWalletBalance();
          this.$emit("close", "Fund Wallet");
        },
      });
      thePeerInstance.setup();
      thePeerInstance.open();
    },

    async cryptoFunding() {
      const tokens = this.currentFundPayload.totalAmount;
      const data = {
        amount: tokens,
        metadata: {
          tokens: Number(tokens),
          entity: "user",
        },

        email: this.user.email,
        name: this.user.name
          ? this.user.name
          : `${this.user.fname} ${this.user.lname}`,
        currency: "USD",
        redirect_url: window.location.href.includes("wallet")
          ? window.location.origin + "/dashboard/wallet"
          : window.location.origin + "/dashboard/overview",
      };
      try {
        const response = await api.fundWithProvider({
          data,
          type: "blockradar",
        });
        window.location = response.data.data.link;
        this.loading = false;
      } catch (error) {
        responseHandler.handleError(error);
        this.loading = false;
      }
    },

    // paymentChannel limits the Flutterwave checkout to the method the user picked.
    async flutterwaveFunding(paymentChannel) {
      const data = {
        amount: this.currentFundPayload.totalAmount,
        currency: this.currency,
        customer: {
          name: this.user.name
            ? this.user.name
            : `${this.user.fname} ${this.user.lname}`,
          email: this.user.email,
        },

        customizations: this.customizations,
        meta: {
          // tokens: Number(
          // 	this.fundPayload.tokens || this.currentFundPayload.totalAmount * 100
          // ),
          entity: "user",
        },

        paymentReference: "",
        redirect_url: window.location.href.includes("wallet")
          ? window.location.origin + "/dashboard/wallet"
          : window.location.origin + "/dashboard/overview",

        payment_options: paymentChannel,
      };
      try {
        const response = await api.fundWithProvider({
          data,
          type: "flutterwave",
        });
        window.location = response.data.data.link;
        this.loading = false;
      } catch (error) {
        responseHandler.handleError(error);
        this.loading = false;
      }
    },

    async accrueFunding() {
      const data = {
        amount: this.currentFundPayload.totalAmount,
        currency: this.currency,
        customer: {
          name: this.user.name
            ? this.user.name
            : `${this.user.fname} ${this.user.lname}`,
          email: this.user.email,
        },
        customizations: this.customizations,
        meta: {
          entity: "user",
        },
        redirect_url: window.location.href.includes("wallet")
          ? window.location.origin + "/dashboard/wallet"
          : window.location.origin + "/dashboard/overview",
      };
      try {
        const response = await api.fundWithProvider({
          data,
          type: "cashramp",
        });
        window.location = response.data.data.link;
        this.loading = false;
      } catch (error) {
        responseHandler.handleError(error);
        this.loading = false;
      }
    },

    async startButtonFunding() {
      const data = {
        amount: this.currentFundPayload.totalAmount,
        currency: this.currency,
        customer: {
          name: this.user.name
            ? this.user.name
            : `${this.user.fname} ${this.user.lname}`,
          email: this.user.email,
        },
        customizations: this.customizations,
        meta: {
          entity: "user",
        },
        redirect_url: window.location.href.includes("wallet")
          ? window.location.origin + "/dashboard/wallet"
          : window.location.origin + "/dashboard/overview",
      };
      try {
        const response = await api.fundWithProvider({
          data,
          type: "startbutton",
        });
        window.location = response.data.data;
        this.loading = false;
      } catch (error) {
        responseHandler.handleError(error);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-card: #FFFFFF;
$bg-subtle: #F1F5F9;
$border-color: #E2E8F0;
$btn-primary: #001240;
$btn-primary-hover: #06206B;
$accent-primary: #6366F1;

.fund-confirmation {
  &__form {
    width: 100%;
  }

  &__card {
    background: $bg-subtle;
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 16px;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 13px;
    color: $text-secondary;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }

    &:not(:last-child) {
      border-bottom: 1px solid $border-color;
    }
  }

  &__label {
    color: $text-muted;
  }

  &__value {
    font-weight: 500;
    color: $text-primary;
  }

  &__total {
    background: $bg-subtle;
    border-radius: 10px;
    padding: 20px 16px;
    margin-bottom: 24px;
    text-align: center;
  }

  &__total-row {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  &__total-label {
    font-size: 13px;
    color: $text-muted;
  }

  &__total-value {
    font-size: 24px;
    font-weight: 600;
    color: $text-primary;
  }

  &__btn {
    width: 100%;
    height: 48px;
    background: $btn-primary;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    color: white;
    cursor: pointer;
    transition: background 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
      background: $btn-primary-hover;
    }

    &:disabled {
      background: $border-color;
      color: $text-muted;
      cursor: not-allowed;
    }
  }

  &__spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
